import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {},
    token: "",
    isAuthenticated: false,
    roles: [],
    code: 0,
    isLoading: "idle"
}

const UserSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        changeUser: (state, action) => {
            state.data = !!action?.payload?.data ? action?.payload?.data : state.data;
            state.token = !!action?.payload?.token ? action?.payload?.token : action?.payload?.token === "" ? action?.payload?.token : state.token;
            state.isAuthenticated = !!action?.payload?.isAuthenticated ? action?.payload?.isAuthenticated : state.isAuthenticated;
            state.roles = !!action?.payload?.roles ? action?.payload?.roles : state.roles;
            state.code = !!action?.payload?.code ? action?.payload?.code : state.code;
        },
        changeUserRole: (state, action) => {
            state.roles = !!action?.payload?.roles ? action?.payload?.roles : state.roles;
            state.isLoading = "pending"
        },
        changeUserRoleIsLoading: (state, action) => {
            // if(!!)
            state.isLoading = "idle"
        },
        changeUserToInit: (state, action) => {
            state.data = {}
            state.token = ""
            state.isAuthenticated = false
            state.roles = []
            state.code = 0
            state.isLoading = "idle"
        },
        reset: () => initialState
    },
});
export const {
    reset,
    changeUser,
    changeUserRole,
    changeUserToInit,
    changeUserRoleIsLoading,
} = UserSlice.actions;

export default UserSlice.reducer;
